<template>
  <div class="pt-8 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">
    <AppSidebar />

    <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <!-- Wiadomość sukcesu lub błędu -->
      <div v-if="message" :class="messageType" 
          class="fixed top-0 left-0 right-0 z-5 p-4 rounded-lg mb-4 text-center 
                  bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border 
                  dark:border-dark-border">
          {{ message }}
          <div class="absolute bottom-0 left-0 h-1 rounded-lg" 
              :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }">
          </div>
      </div>

      <h1 class="text-xl md:text-2xl font-bold mb-4 text-center lg:text-left">Stacje Kolejowe</h1>

      <StationCreateModal
          :isOpen="isModalOpen"
          @close="closeModal"
          @submit="handleOrderSubmit"
      />

      <StationEditModal
          :isOpen="isEditModalOpen"
          :stationToEdit="editingStation"
          @close="closeEditModal"
          @submit="handleOrderEditSubmit"
      />

      <div class="bg-white p-4 rounded-lg shadow-md w-full h-auto overflow-visible dark:bg-dark-box-bg dark:border dark:border-dark-border">
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-gray-700 dark:text-dark-text">Lista Stacji Kolejowych:</h2>

          <DynamicSearch
              :data="stations"
              :keysToSearch="['name', 'mainCode']"
              @search-results="handleSearchResults"
              @clear-search="clearSearch"
              class="mt-4 bg-gray-200 dark:bg-dark-box-bg text-gray-900 dark:text-dark-text w-full md:w-auto"
              placeholder="Wyszukaj..."
          />
        </div>

        <div class="overflow-x-auto w-full">
          <table class="min-w-full bg-white border border-gray-300 rounded-lg dark:bg-dark-table-bg dark:border-dark-border">
            <thead>
            <tr class="bg-gray-50 dark:bg-dark-table-header">
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Nazwa stacji
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Kod pocztowy
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Województwo
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Kod główny stacji
              </th>
              <!-- <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-right text-sm font-semibold text-gray-700 dark:text-dark-text">
                Akcje
              </th> -->
            </tr>
            </thead>
            <tbody>
            <tr v-if="pagedStations.length === 0">
              <td colspan="3" class="text-center py-4 text-red-500 font-semibold dark:text-dark-status-unavailable">
                Brak Stacji Kolejowych
              </td>
            </tr>
            <tr
                v-else
                v-for="(station) in pagedStations"
                :key="station.id"
                :class="[
                    'border-b border-gray-300 dark:border-dark-border hover:bg-light-hover dark:hover:bg-dark-hover hover:cursor-pointer',
                    selectedStation && station.id === selectedStation.id ? 'bg-light-hover dark:bg-dark-hover' : ''
                ]"
                @click="showStationDetails(station)"
            >
              <td class="py-3 px-4 dark:text-dark-text">{{ station.name }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ station.postcode }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ station.voivodeShip }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ station.mainCode }}</td>
              <!-- <td class="py-3 px-4 text-right dark:text-dark-text">
                <div class="relative inline-block text-left">
                  <button @click.stop="toggleDropdown(station.id)" class="text-gray-500 hover:text-gray-700 dark:text-dark-text">
                    <EllipsisVerticalIcon class="h-5 w-5" />
                  </button>
                  <div v-if="dropdownOpen === station.id" class="origin-top-right absolute left-0 ml-[-10rem] mt-[-2.2rem] w-40 focus:outline-none">
                    <div class="py-1.5 absolute flex space-x-2 bg-gray-200 dark:bg-gray-900 rounded">
                      <button @click.stop="startEditing(station)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <PencilIcon class="w-4 h-4" />
                      </button>
                      <button @click.stop="deleteStation(station.id)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <TrashIcon class="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </td> -->
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginacja -->
        <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
            Wyświetlono {{ (currentPage - 1) * itemsPerPage + pagedStations.length }} z {{ filteredStations.length }} stacji
          </div>


          <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
            <button v-if="currentPage > 1"
                    @click="goToPage(1)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Pierwsza strona
            </button>
            <button v-if="currentPage > 1"
                    @click="prevPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              &laquo; Poprzednia
            </button>
            <button v-for="page in visiblePages"
                    :key="page"
                    @click="goToPage(page)"
                    :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                    class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
              {{ page }}
            </button>
            <button v-if="currentPage < totalPages"
                    @click="nextPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Następna &raquo;
            </button>
            <button v-if="currentPage < totalPages"
                    @click="goToPage(totalPages)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Ostatnia strona
            </button>
          </div>
        </div>
      </div>

      <button
          @click="openModal"
          class="fixed bottom-8 right-8 bg-button-bg text-button-text p-4 rounded-full shadow-md transition-transform duration-200 ease-in-out hover:bg-button-hover dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
      >
        <PlusIcon class="h-6 w-6 transition-transform duration-200 ease-in-out transform hover:rotate-45" />
      </button>
    </div>
  </div>

  <StationInformationModal
            v-if="showModal"
            :visible="showModal"
            :title="'Szczegóły Stacji #' + (selectedStation?.id || '')"
            :selectedStation="selectedStation"
            :userRole="user.role"
            @close="closeModalInformation"
            @startEditing="startEditing"
            @deleteStation="deleteStation"
      >
          <div class="space-y-4">
            <p><b>Nazwa stacji:</b> {{ selectedStation?.name }}</p>
            <p><b>Kod Stacji:</b> {{ selectedStation?.mainCode }}</p>
            <p><b>Województwo:</b> {{ selectedStation?.voivodeShip }}</p>
            <p><b>Kod pocztowy:</b> {{ selectedStation?.postcode }}</p>
          </div>
  </StationInformationModal>
</template>


<script>
import stationService from '@/services/stationService';
import AppSidebar from '../AppSidebar.vue';
import DynamicSearch from '../search/DynamicSearch.vue';
import { PlusIcon } from "@heroicons/vue/24/solid";
import { useAuthStore } from '@/stores/authStore';
import StationEditModal from './StationEditModal.vue';
import StationCreateModal from './StationCreateModal.vue';
import StationInformationModal from './StationInformationModal.vue';

export default {
    name: 'StationsPageDispatcher',
    components: {
        AppSidebar,
        DynamicSearch,
        // EllipsisVerticalIcon,
        // PencilIcon,
        // TrashIcon,
        PlusIcon,
        StationEditModal,
        StationCreateModal,
        StationInformationModal
    },
    setup() {
        const authStore = useAuthStore();
        authStore.checkExpiration();
        return { user: authStore.user, authStore };
    },
    data() {
        return {
            stations: [],
            filteredStations: [],
            editingStation: null,
            isModalOpen: false,
            isEditModalOpen: false,
            message: '',
            messageType: '',
            currentPage: 1,
            itemsPerPage: 5,
            progress: 0,
            dropdownOpen: null,
            loading: false,
            showModal: false,
            selectedStation: null,
            isSecureContext: false,
        };
    },
    mounted() {
      this.calculateItemsPerPage();
      window.addEventListener("resize", this.calculateItemsPerPage);

      this.fetchStations();

      setInterval(() => {
        if (!this.isSearching) {
          this.fetchStations();
        }
      }, 10000); // Odświeżanie co 10 sekund
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.calculateItemsPerPage);
    },
    computed: {
        pagedStations() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredStations.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.filteredStations.length / this.itemsPerPage);
        },
        visiblePages() {
            const maxVisible = 5; // Maksymalna liczba widocznych stron
            const startPage = Math.max(this.currentPage - Math.floor(maxVisible / 2), 1);
            const endPage = Math.min(startPage + maxVisible - 1, this.totalPages);

            const pages = [];
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        calculateItemsPerPage() {
          const width = window.innerWidth;

          if (width >= 3840) {
            this.itemsPerPage = 24; // 4K monitor
          } else if (width >= 2560) {
            this.itemsPerPage = 15; // 2K monitor
          } else if (width >= 1920) {
            this.itemsPerPage = 8; // Full HD monitor
          } else {
            this.itemsPerPage = 5; // Standardowa wartość
          }

          this.calculateTotalPages();
        },
        calculateTotalPages() {
          this.totalPages = Math.ceil(this.filteredStations.length / this.itemsPerPage) || 1;
          this.updateVisiblePages();
        },
        updateVisiblePages() {
          const range = 5; // Liczba widocznych stron
          const start = Math.max(1, this.currentPage - Math.floor(range / 2));
          const end = Math.min(start + range - 1, this.totalPages);

          this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
        showStationDetails(station) {
          this.selectedStation = station; // Przypisz wybrane zamówienie
          this.showModal = true; // Pokaż modal
        },
        closeModalInformation() {
          this.selectedStation = null; // Wyczyść dane zamówienia
          this.showModal = false; // Zamknij modal
        },
        handleSearchResults(filteredData) {
            this.filteredStations = filteredData;
            this.currentPage = 1;

            this.isSearching = filteredData.length > 0;

            this.goToPage(1);
        },
        clearSearch() {
          this.isSearching = false;

          this.goToPage(1);
        },
        toggleDropdown(stationId) {
            this.dropdownOpen = this.dropdownOpen === stationId ? null : stationId;
        },
        showMessage(msg, type) {
            this.message = msg;
            this.messageType = type === 'success' ? 'success-message' : 'error-message';
            this.progress = 0;

            const interval = 30;
            const duration = 5000;
            const step = 100 / (duration / interval);

            const progressInterval = setInterval(() => {
                this.progress += step;
                if (this.progress >= 100) {
                clearInterval(progressInterval);
                this.progress = 0;
                this.message = '';
                this.messageType = '';
                }
            }, interval);
        },
        openModal() {
            if (!this.isModalOpen) {
            this.isModalOpen = true;
            }
        },
        closeModal() {
            if (this.isModalOpen) {
            this.isModalOpen = false;
            }
        },
        handleOrderSubmit(newStation) {
            if (!this.loading) {
                this.submitCreate(newStation);
            }
        },
        startEditing(station) {
            this.showModal = false;
            this.openEditModal(station);
        },
        openEditModal(station) {
            this.editingStation = station;
            this.isEditModalOpen = true;
        },
        closeEditModal() {
            this.isEditModalOpen = false;
            this.editingStation = null;
        },
        handleOrderEditSubmit(editingStation) {
            if (!this.loading) {
                this.submitEdit(editingStation);
            }
        },
        async submitCreate(newStation) {
            if (this.loading) return;

            this.loading = true;

            try {
                const stationData = {
                    id: newStation.id,
                    name: newStation.name,
                    postcode: newStation.postcode,
                    voivodeShip: newStation.voivodeShip,
                    mainCode: newStation.mainCode,
                };

                await stationService.createStation(stationData);
                this.showMessage("Stacja kolejowa została pomyślnie dodana.", "success");

                await this.fetchStations();
                this.resetNewStation();
                this.closeModal();
            } catch (error) {
                this.showMessage("Wystąpił błąd podczas dodawania stacji.", "error");
                console.error('Błąd podczas tworzenia zamówienia:', error);
            } finally {
                this.loading = false;
            }
        },
        async submitEdit(editingStation) {
            if (this.loading) return;

            this.loading = true;
            try {
                const stationData = {
                    id: editingStation.id,
                    name: editingStation.name,
                    postcode: editingStation.postcode,
                    voivodeShip: editingStation.voivodeShip,
                    mainCode: editingStation.mainCode,
                };

                await stationService.updateStation(stationData.id, stationData);
                this.showMessage("Stacja została pomyślnie zaktualizowana.", "success");

                await this.fetchStations();
                this.closeEditModal();
            } catch (error) {
                this.showMessage("Wystąpił błąd podczas aktualizacji stacji.", "error");
                console.error('Błąd podczas aktualizacji zamówienia:', error);
            } finally {
                this.loading = false;
            }
        },
        getProgressColor() {
            return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
        },
        resetNewStation() {
            this.newStation = {
                name: '',
                postcode: '',
                voivodeShip: '',
                mainCode: ''
            };
        },
        async deleteStation(stationId) {
            if (confirm("Czy na pewno chcesz usunąć tą stacje?")) {
                try {
                    await stationService.deleteStation(stationId);
                    await this.fetchStations();
                    this.showMessage("Stacja została pomyślnie usunięta.", "success");
                    this.closeModalInformation();
                } catch (error) {
                    console.error('Błąd podczas usuwania stacji:', error);
                    this.showMessage("Wystąpił błąd podczas usuwania stacji.", "error");
                }
            }
        },
        async fetchStations() {
            try {
                const response = await stationService.getAllStations();
                this.stations = response.data;
                this.filteredStations = this.stations;
                this.loading = false;
            } catch (error) {
                this.errorMessage = 'Błąd podczas pobierania szczegółów stacji. Spróbuj ponownie.';
                this.loading = false;
            }
        },
        goToPage(page) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
    }
}
</script>